module.exports = "/assets/data/2fb88b88fdeeb6c2e4a2a3e75e68da7f-LS22.data.json";